import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=538ddce0&"
import script from "./ModalRoot.vue?vue&type=script&lang=js&"
export * from "./ModalRoot.vue?vue&type=script&lang=js&"
import style0 from "./ModalRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports